import { render, staticRenderFns } from "./Departments-table.vue?vue&type=template&id=7375b147&"
import script from "./Departments-table.vue?vue&type=script&lang=js&"
export * from "./Departments-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports